import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as svg from 'node_modules/save-svg-as-png';
@Component({
  selector: 'app-qr-dialog',
  templateUrl: './qr-dialog.component.html',
  styleUrls: ['./qr-dialog.component.scss']
})
export class QRDialogComponent implements OnInit {
  @ViewChild('userQRCont', { static: true }) userQRCont: ElementRef;
  public header: string;
  public QRimgSrc: string = '';
  public spinnerDownload: boolean = false;

  private qrGenerator: BrowserQRCodeSvgWriter;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.qrGenerator = new BrowserQRCodeSvgWriter();
  }

  ngOnInit() {
    this.header = `QR Fiserv - ${this.data.cashierName}`;
    this.qrGenerator.writeToDom('#userQR', this.data.qrData, 380, 380);
    this.showQR();
  }

  async showQR() {
    this.QRimgSrc = await svg.svgAsPngUri(this.userQRCont.nativeElement.children[0], { backgroundColor: 'white' });
  }

  printQR() {
    window.print();
  }

  async downloadQR() {
    this.spinnerDownload = true;
    const dataURI = await svg.svgAsPngUri(this.userQRCont.nativeElement.children[0], { backgroundColor: 'white' });
    this.triggerDataDownload(dataURI, 'QR Fiserv.png');
  }

  private triggerDataDownload(dataUrl: string, filename: string) {
    const isData = typeof dataUrl === 'string' && dataUrl.startsWith('data:');
    const preview = isData ? dataUrl.slice(0, 80) + '…' : String(dataUrl);
    const isBase64 = typeof dataUrl === 'string' && dataUrl.includes(';base64,');
    const mime = isData ? dataUrl.substring(5, dataUrl.indexOf(';')) : 'unknown';
    console.log('[QRDialogComponent] data URL check', { isData, isBase64, mime, preview });
    const anchor = document.createElement('a');
    anchor.href = dataUrl;
    if ('download' in anchor) {
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } else {
      window.location.href = dataUrl;
    }
    this.spinnerDownload = false;
  }
}
